import { api } from './api';

export interface SessionHistoryItem {
  sessionId: number;
  courseId: number;
  startedAt: string;
  endedAt: string | null;
  durationMinutes: number | null;
  topicsVisited: string[];
}

export async function getTutorSessionHistory(courseId: number): Promise<SessionHistoryItem[]> {
  const response = await api.get<{ data: SessionHistoryItem[] }>(
    `/api/tutor/courses/${courseId}/session/history`
  );
  return response.data.data ?? [];
}

export async function getParentSessionHistory(courseId: number): Promise<SessionHistoryItem[]> {
  const response = await api.get<{ data: SessionHistoryItem[] }>(
    `/api/parent/courses/${courseId}/sessions`
  );
  return response.data.data ?? [];
}
